import request from '../request';

export const getFeedsSkipLimit = (skip = 0, limit = 5, filter) =>
  request.post(`/feed/list/skip/${skip}/limit/${limit}`, filter).then((res) => res);

export const getFeedsForWallSkipLimit = (skip = 0, limit = 5, filter) =>
  request.post(`/feed/wall/skip/${skip}/limit/${limit}`, filter).then((res) => res);

export const getFeedById = (id) => request.get(`/feed/${id}`).then((res) => res);

export const createFeed = (data) => request.post(`/feed`, data).then((res) => res);

export const updateFeedById = (id, data) => request.put(`/feed/${id}`, data).then((res) => res);

export const archiveFeedById = (id) => request.delete(`/feed/${id}/archive`).then((res) => res);

export const deleteFeedById = (id) => request.delete(`/feed/${id}`).then((res) => res);

export const previewFeedNotification = (feedId, data) =>
  request.post(`/feed/${feedId}/preview-notification`, data).then((res) => res);

export const sendFeedNotification = (feedId, data) =>
  request.post(`/feed/${feedId}/send-notification`, data).then((res) => res);
